import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <>{children}</>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "data-and-options"
    }}>{`Data and options`}</h3>
    <p>{`Data and options follow the same model in all charts, with minor exceptions and differences in specific components.`}</p>
    <p>{`For instance, in the case of pie and donut charts, you would only provide one data set. In the case of donut charts, you can pass in an additional field called `}<inlineCode parentName="p">{`center`}</inlineCode>{` in your options configuring the donut center.`}</p>
    <p>{`There are also additional options available depending on the chart type being used, for more examples please see `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-charts/tree/master/packages/core/demo/demo-data"
      }}>{`here`}</a>{`.`}</p>
    <p>{`Below are sample data and options that can be used in a stacked bar chart:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const stackedBarData = {
  labels: ['Quantity', 'Leads', 'Sold', 'Restocking', 'Misc'],
  datasets: [
    {
      label: 'Dataset 1',
      data: [65000, 29123, 35213, 51213, 16932],
    },
    {
      label: 'Dataset 2',
      data: [32432, 21312, 56456, 21312, 34234],
    },
    {
      label: 'Dataset 3',
      data: [12312, 23232, 34232, 12312, 34234],
    },
  ],
};

const stackedBarOptions = {
  title: 'Stacked bar (discrete)',
  axes: {
    left: {
      primary: true,
      stacked: true,
    },
    bottom: {
      scaleType: 'labels',
      secondary: true,
    },
  },
  height: '400px',
};
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      